// import annotateElement from '../../annotator';
import * as actionCreator from '../../store/actions';
import { getOffset, applyOffset } from './offset';

function ensureVisible(el, wrapper) {
  if (el !== wrapper) {
    el.classList.add('flash-parent');
    ensureVisible(el.parentElement, wrapper);
  }
}

function clearFlash(el) {
  Array.prototype.map.call(document.querySelectorAll('.flash-parent'), parent => parent.classList.remove('flash-parent'));
  el.classList.remove('flash');
}

function flash(el, wrapper) {
  ensureVisible(el.parentElement, wrapper);
  el.classList.add('flash');
  setTimeout(() => clearFlash(el), 1000);
}

class Viewer {
  constructor(props) {
    this.html = document.createElement('div');
    this.html.setAttribute('kjuicer-component-viewer', true);

    this.handleClick = this.handleClick.bind(this);
    this.init = this.init.bind(this);
    this.update = this.update.bind(this);
    this.render = this.render.bind(this);

    this.html.addEventListener('click', this.handleClick.bind(this));
    if (props) {
      this.init(props);
    }
  }

  handleClickNested(e, node) {
    e.preventDefault();
    flash(node, this.html);
    this.store.dispatch(actionCreator.anchorTo(
      node.dataset.uid,
      getOffset(e.target, this.html, this.config.isSelfContained),
    ));
    if (this.config.level > 0) {
      this.store.dispatch(actionCreator.prevLevel());
    }
  }

  handleClick(e) {
    const { target } = e;
    const { parentElement: parent } = target;
    if (target.nodeName === 'MARK' && target.getAttribute('data-level')) {
      this.handleClickNested(e, target);
    } else if (parent.nodeName === 'MARK' && parent.getAttribute('data-level')) {
      this.handleClickNested(e, parent);
    }
  }

  init(params, store = null) {
    this.config = { ...params };
    this.store = store;
    this.config.html = this.config.html || '';
    if (this.config.viewer_class) {
      this.html.className = this.config.viewer_class;
    }
    this.render();
  }

  update(params) {
    if (this.config.level !== params.level) {
      if (params.anchor) {
        const ps = {
          ...params,
          anchor: document.querySelector(`mark[data-uid="${params.anchor}"]`),
        };
        flash(ps.anchor, this.html);
        applyOffset(ps, this.html, ps.isSelfContained);
      }

      this.config = { ...this.config, ...params };
      return;
    }

    if (params.prev && params.prev.highlighters.length !== params.highlighters.length) {
      this.config = { ...this.config, ...params };
      this.render();
    }

    if (this.config.html === params.html) {
      this.config = { ...this.config, ...params };
      return;
    }

    this.config = { ...this.config, ...params };
    this.render();
  }

  render() {
    this.html.innerHTML = this.config.html;
    // annotateElement(this.html, null, this.config.highlighters.length);
    if (this.config.anchor && !document.contains(this.config.anchor)) {
      this.store.dispatch(actionCreator
        .anchorTo(null, 0));
    }
  }
}

export default Viewer;
